import React from 'react'
import Pt from 'prop-types'
import {Button, Col, InputGroup, Panel, Row} from 'react-bootstrap'

import { SignupWithExternalsRecord } from 'internal-components/src/records'

import DetailTable from '../SignupDetails/DetailTable'
import Qualification from '../SignupDetails/Qualification'
import {connect} from "react-redux";
import * as signupActions from "../../redux/modules/signupEdit/actions";
import Icon from "internal-components/src/components/Icon";

const heardAboutOptions = [
  'Google',
  'nbn Co. Website',
  'Radio',
  'Word of mouth',
  'Other (please specify)',
]
const heardAboutOther = heardAboutOptions[heardAboutOptions.length - 1];

class Completed extends React.Component {
  propTypes = {
    downloadPdf: Pt.func.isRequired,
    signupWithExternals: Pt.instanceOf(SignupWithExternalsRecord).isRequired,
    submitHeardAbout: Pt.func.isRequired,
  }

  state = {
    heardAboutOption: null,
    heardAboutFreeText: '',
    heardAboutSubmitted: false,
    heardAboutSubmitting: false,
  }

  submitHeardAbout() {
    let heardAboutAnswer;
    if (this.state.heardAboutOption === heardAboutOther) {
      if (this.state.heardAboutFreeText) {
        heardAboutAnswer = this.state.heardAboutFreeText;
      }
    } else if (this.state.heardAboutOption) {
      heardAboutAnswer = this.state.heardAboutOption;
    }
    if (heardAboutAnswer) {
      this.props.submitHeardAbout(
        heardAboutAnswer,
        this.props.signupWithExternals,
      )
      this.setState({heardAboutSubmitting: true})
      setTimeout(() => this.setState({heardAboutSubmitted: true}), 700);
    }
  }

  render() {
    const { signupWithExternals } = this.props

    return (
        <div className="signup-completed">
          {signupWithExternals.product.get('addressRequired') && (
              <Qualification signupWithExternals={signupWithExternals}/>
          )}

          <Row>
            <Col md={12}>
              <h3>Success!</h3>
              <h4>Thanks for signing up with Infinite Networks!</h4>

              <p>
                We will email you with the details regarding your service as they
                become available.
              </p>

              <p>
                In the mean time, should you have any questions about your service
                please contact us on 1300 790 337 or email{' '}
                <a href="mailto:support@infinite.net.au">support@infinite.net.au</a>{' '}
                with the reference{' '}
                <strong>{signupWithExternals.signup.get('reference')}</strong>.
              </p>

              <Panel bsStyle="info">
                <Panel.Body>
                  {this.state.heardAboutSubmitted
                    ? <p>Thank you for the feedback!</p>
                    : <div>
                      <h4>How did you hear about Infinite Networks?</h4>
                      {heardAboutOptions.map(o => <div key={o}>
                          <label>
                            <input type="radio" onClick={() => this.setState({heardAboutOption: o})} checked={this.state.heardAboutOption === o} /> {o}
                          </label>{' '}
                        {o === heardAboutOther && <input value={this.state.heardAboutFreeText} onChange={(e) => this.setState({
                          heardAboutFreeText: e.target.value,
                          heardAboutOption: heardAboutOther,
                        })} />}
                        </div>)}
                      <div style={{marginTop: 20, marginLeft: 50}}>
                        <Button type="submit" bsStyle="primary" onClick={() => this.submitHeardAbout()} disabled={this.state.heardAboutSubmitting}>
                          Submit
                        </Button>
                      </div>
                    </div>}
                </Panel.Body>
              </Panel>
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <DetailTable signupWithExternals={signupWithExternals}/>
              {signupWithExternals.signup.get('state') !== 'new' && (
                <Button bsSize="large" bsStyle="info" onClick={() => this.props.downloadPdf(signupWithExternals.signup)}>
                  <Icon name="file-pdf-o" /> Print
                </Button>
              )}
            </Col>
          </Row>
        </div>
    )
  }
}

const mapStateToProps = state => {return {}}

export default connect(
  mapStateToProps,
  signupActions,
)(Completed)



// WEBPACK FOOTER //
// ./src/components/Signup/Completed.jsx